// src/pages/RolesPage.jsx
import React from "react";
import CreateRoleForm from "../components/CreateRoleForm";

const RolesPage = () => {
  return (
  <div style={{ padding: 2 ,fontSize: "12px" }}>
      <h2>Manage Roles</h2>
      
      <CreateRoleForm />
      {/* Add role list + edit functionality here if needed */}
    </div>
  );
};

export default RolesPage;
